/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { LegalHintsItemFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { LegalHintsItemFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const legalHintsItemDataMock: LegalHintsItemFragmentFragment = {
  iconUrl: 'https://bilder.baur.de/i/empiriecom/legal_ruecksendung_rueckgaberecht',
  text: 'Rückgabegarantie mit kostenlosem Rückversand',
  serviceLayerId: 'legal_ruecksendung_rueckgaberecht',
  dialogContent: null,
};

export function getLegalHintsItemFragmentedData(data?: LegalHintsItemFragmentFragment) {
  return makeFragmentData(data || legalHintsItemDataMock, LegalHintsItemFragmentFragmentDoc);
}
